import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from '../../auth/shared/services/auth.service';
import {AuthQuery} from '../elf-store/auth/auth.query';
import {AutoUnsubscribe} from '../../decorators/auto-unsubscribe.decorator';
import {SUBSCRIPTIONS} from '../utils/constants';

@Injectable()
@AutoUnsubscribe()
export class TokenInterceptor implements HttpInterceptor {
  token: string;

  constructor(
    private auth: AuthService,
    private authQuery: AuthQuery,
  ) {
    this[SUBSCRIPTIONS].add(this.authQuery.token$.subscribe(token => (this.token = token)));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.auth.isUserAuthenticated()) {
      if (request.headers.get('skip')) {
        request = request.clone({headers: request.headers.delete('skip', 'true')});
      } else {
        request = request.clone({setHeaders: {'Content-Type': 'application/json'}});
      }

      if (!request.headers.get('authorization')) {
        request = request.clone({
          setHeaders: {
            'x-auth-token': this.token,
            authorization: this.token, // some endpoints require authorization field name
          },
        });
      }
    }

    return next.handle(request);
  }
}
